var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.userLists),function(list,index){return _c('div',{key:list.objectId,staticClass:"list-item topIn",style:({
      'animation-delay': ((200 * index) + "ms"),
      'animation-fill-mode': 'backwards !important'
    }),on:{"click":function($event){_vm.goToList(list)}}},[_c('img',{attrs:{"src":list.get('cover').get('url'),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"list-item-msg"},[_c('div',[_vm._v(_vm._s(list.get('name')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(list.get('worksCount')))])])])}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4dae485e","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user-msg/UserMsgLists.vue
// module id = 1541
// module chunks = 0